export default function Toggle({ label, on, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "18px 24px",
        background: "rgba(255,255,255,0.03)",
        borderRadius: "14px",
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <span style={{ flex: 1, marginRight: "16px", fontWeight: "500" }}>
        {label}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <span
          style={{
            fontSize: "14px",
            color: on ? "#00d4aa" : "#ff4757",
            fontWeight: "600",
          }}
        >
          {on ? "Ja" : "Nei"}
        </span>
        <div
          className={`toggle ${on ? "on" : ""}`}
          onClick={() => onChange(!on)}
        />
      </div>
    </div>
  );
}
